function tabNameFormatter(tabs, guests) {
  let _tabs = tabs
    .filter(tab => !!tab.guest_id)
    .map(tab => {
      const guest = guests.find(guest => guest.id === tab.guest_id);

      return {
        name: !!guest ? `${guest.first_name} ${guest.last_name}` : 'Unnamed Booking',
        image_uri: !!guest
          ? guest.photo_md_uri || guest.photo_uri
          : '',
        id: tab.id,
        guest_id: tab.guest_id,
        isActive: tab.is_active,
        isOpen: tab.is_open,
        bookingId: tab.booking_id,
        subtotal: `${parseFloat(tab.stats.sub_total).toFixed(2)}`,
        balanceDue: `${parseFloat(tab.stats.balance_due).toFixed(2)}`,
        createdAt: tab.created_at
      }
    });

  return _.uniq(_tabs).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

export {tabNameFormatter};
